import { styled } from '@linaria/react';
import { useLingui } from '@lingui/react/macro';
import { isNonEmptyString } from '@sniptt/guards';
import { PRODUCT_NAME } from 'app-shared/constants';
import { Button } from 'app-ui/primitives/input';
import { themeCssVariables } from 'app-ui/theme';

import { DEMO_BANNER_URL } from '@/demo-account/constants/DemoBannerUrl';

const StyledBanner = styled.aside`
  align-items: center;
  background: ${themeCssVariables.accent.accent2};
  border-bottom: 1px solid ${themeCssVariables.accent.accent5};
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: ${themeCssVariables.spacing[2]} ${themeCssVariables.spacing[4]};
  justify-content: space-between;
  padding: ${themeCssVariables.spacing[2]} ${themeCssVariables.spacing[4]};
`;

const StyledMessage = styled.p`
  align-items: center;
  color: ${themeCssVariables.font.color.primary};
  display: flex;
  flex-wrap: wrap;
  font-size: ${themeCssVariables.font.size.sm};
  gap: ${themeCssVariables.spacing[2]};
  margin: 0;
`;

const StyledBadge = styled.span`
  background: ${themeCssVariables.accent.accent9};
  border-radius: ${themeCssVariables.border.radius.pill};
  color: ${themeCssVariables.font.color.onAccent};
  font-size: ${themeCssVariables.font.size.xs};
  font-weight: ${themeCssVariables.font.weight.semiBold};
  padding: ${themeCssVariables.spacing['0.5']} ${themeCssVariables.spacing[2]};
`;

// Above every page of a public demo (VITE_DEMO_BANNER_URL): says it is a
// demo and leads to where the product is sold, in a new tab so the demo
// stays open.
export const DemoBanner = () => {
  const { t } = useLingui();

  if (!isNonEmptyString(DEMO_BANNER_URL)) {
    return null;
  }

  return (
    <StyledBanner aria-label={t`About this demo`}>
      <StyledMessage>
        <StyledBadge>{t`Demo`}</StyledBadge>
        {t`This is a live demo of ${PRODUCT_NAME}: everything you see here comes with it.`}
      </StyledMessage>
      <Button
        size="sm"
        variant="solid"
        color="accent"
        href={DEMO_BANNER_URL}
        target="_blank"
        rel="noopener"
      >
        {t`Get ${PRODUCT_NAME}`}
      </Button>
    </StyledBanner>
  );
};
